import { render, staticRenderFns } from "./Dozenteneinsatz.vue?vue&type=template&id=230e62d4"
import script from "./Dozenteneinsatz.vue?vue&type=script&lang=js"
export * from "./Dozenteneinsatz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports